import { keyBy } from 'lodash';
import { useEffect, useState } from 'react';
import { HEADER_CONFIG } from '../../../utils/const/router';
import CardInfo from '../cardInfo/card-info';
import CommonCardStyles from './common-card.module.scss';
import { ProductInfo } from '@/services/document';

/**
 * productCode productName
  VOD	点播云
  MEDIASDK	音视频SDK
  RTC	实时音视频
  VTM	虚拟人
  VIDEOMEETING	快手闪电
  INTELLG-AUDIT	智能审核
  INTELLG-TAG	智能标签
  INTELLG-VFX	智能特效
  FACE-BUTI	人像美化
  MPS	媒体处理
  PRD2	快手云剪
  PRD3	快手极目
  SMX	SoundMatrix
  PRD4	原创保护
  PRD5	质量分析
  PRD6	智能大屏
  PRD7	智能创作
  PRD8	直播云
  ACS	访问控制
  POL	法律协议
  ACC	账号相关
  BIL	费用相关
 */
export const WHITE_LIST = ['VOD', 'PRD3', 'PRD8', 'RTC'];

export default function CommonCard({
  productType,
  mediaDesc,
}: {
  /**文档卡片类别标题 */
  productType: string;
  /**文档卡片列表 */
  mediaDesc: ProductInfo[];
  /**卡片组类型，如果是product按导航顺序映射 */
  type?: string;
}) {
  const [products, setProducts] = useState<ProductInfo[]>([]);
  useEffect(() => {
    const config = (
      HEADER_CONFIG.find((item) => item.key === 'products').children as {
        title: string;
        subtitle?: string;
        items: { title: string; link: string }[];
      }[]
    ).find((item) => item.title === productType)?.items;
    if (config) {
      const data = keyBy(mediaDesc, 'productName');
      let res = config
        .map((item) => data[item.title])
        .filter((item) => item !== undefined);
      // NOTE: 发布会前定制需求，勿喷
      if (productType === 'StreamLake-Video') {
        res = res.filter((item) => WHITE_LIST.includes(item.productCode));
      }
      setProducts(res);
    } else {
      setProducts(mediaDesc);
    }
  }, []);
  return (
    <div className={CommonCardStyles['card']}>
      <div className={CommonCardStyles['card-name']}>{productType}</div>
      <div className={CommonCardStyles['card-content']}>
        {products.map((item) => {
          return <CardInfo item={item} key={item.id} />;
        })}
      </div>
    </div>
  );
}
